var map = {
	"./2026-01-25-2010/index.en.md": 397,
	"./2026-01-25-2010/index.ko.md": 18936,
	"./2026-02-05-0000/index.en.md": 52489,
	"./2026-02-05-0000/index.ko.md": 10300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54611;